import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Caption = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1377 2.70947C4.1377 2.29526 3.80191 1.95947 3.3877 1.95947C2.97348 1.95947 2.6377 2.29526 2.6377 2.70947V9.9886C2.6377 10.9551 3.4212 11.7386 4.38769 11.7386H15.4805C16.447 11.7386 17.2305 10.9551 17.2305 9.9886V2.70947C17.2305 2.29526 16.8947 1.95947 16.4805 1.95947C16.0663 1.95947 15.7305 2.29526 15.7305 2.70947V9.9886C15.7305 10.1267 15.6185 10.2386 15.4805 10.2386H4.38769C4.24962 10.2386 4.1377 10.1267 4.1377 9.9886V2.70947ZM2.6377 13.981C2.6377 13.5668 2.97348 13.231 3.3877 13.231H15.9292C16.3434 13.231 16.6792 13.5668 16.6792 13.981C16.6792 14.3952 16.3434 14.731 15.9292 14.731H3.3877C2.97348 14.731 2.6377 14.3952 2.6377 13.981ZM2.64473 16.869C2.64473 16.4548 2.98052 16.119 3.39473 16.119H10.0001C10.4144 16.119 10.7501 16.4548 10.7501 16.869C10.7501 17.2832 10.4144 17.619 10.0001 17.619H3.39473C2.98052 17.619 2.64473 17.2832 2.64473 16.869Z"
        fill={color}
      />
    </svg>
  )
})

export default Caption
